export default {
  MAX_NETSUITE_UPLOAD_SIZE: 10000000,

  validEmail (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  },

  validZip (zip) {
    const countryField = document.getElementById('country-dropdown')
    const countryCode = countryField.options[countryField.selectedIndex].value

    switch (countryCode) {
      // US
      case '230':
      case 'US':
      // Original code updated to accept all valid US zip codes (XXXXX-YYYY was incorrectly marked as invalid)
      // return /^\d{5}$/.test(zip)
      // SO: https://stackoverflow.com/a/56739221/2096769
        return /^\d{5}[-\s]?(?:\d{4})?$/.test(zip)
      // Canada
      case '37':
      case 'CA':
        return /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip)
      // Argentina
      case 'AR':
      case '11': {
        // old format
        const oldFormat = /^\d{4}$/.test(zip)
        const newFormat = /^[A-Za-z]{3}\d{4}[A-Za-z]{3}]$/.test(zip)
        return oldFormat || newFormat
      }
      // Australia
      case '14':
      case 'AU':
        return /^\d{4}$/.test(zip)
      // Austria
      case '13':
      case 'AT':
        return /^\d{4}$/.test(zip)
      // Belgium
      case '20':
      case 'BE':
        return /^\d{4}$/.test(zip)
      // Bulgaria
      case '22':
      case 'BG':
        return /^\d{4}$/.test(zip)
      // Croatia
      case '98':
      case 'HR':
        return /^\d{5}$/.test(zip)
      // Cyprus
      case '55':
      case 'CY':
        return /^\d{4}$/.test(zip)
      // Czech Republic/Czechia
      case '56':
      case 'CZ':
        return /^\d{6}$/.test(zip)
      // Denmark
      case '59':
      case 'DK':
        return /^\d{4}$/.test(zip)
      // Estonia
      case '64':
      case 'EE':
        return /^\d{5}$/.test(zip)
      // Finland
      case '70':
      case 'FI':
        return /^\d{5}$/.test(zip)
      // France
      case '75':
      case 'FR':
        return /^\d{5}$/.test(zip)
      // Germany
      case '57':
      case 'DE':
        return /^\d{5}$/.test(zip)
      // Greece
      case 'GR':
      case '89':
        return /^\d{3}? \d{2}$/.test(zip)
      // Hungary
      case '100':
      case 'HU':
        return /^\d{4}$/.test(zip)
      // Iceland
      case '109':
      case 'IS':
        return /^\d{3}$/.test(zip)
      // Ireland
      case '102':
      case 'IE':
        return /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/.test(zip)
      // Israel
      case '103':
      case 'IL':
        return /^\d{7}$/.test(zip)
      // Italy
      case '110':
      case 'IT':
        return /^\d{5}$/.test(zip)
      // Latvia
      case '135':
      case 'LV':
        return /^([Ll][Vv][- ]{0,1})[0-9]{4}$/.test(zip)
      // Lithuania
      case '133':
      case 'LT':
        return /^([Ll][Tt][- ]{0,1}){0,1}\d{5}$/.test(zip)
      // Luxemborg
      case '134':
      case 'LU':
        return /^\d{4}$/.test(zip)
      // Malta
      case '153':
      case 'MT':
        return /^[A-Za-z]{3}\s{0,1}\d{4}$/.test(zip)
      // Mexico
      case '157':
      case 'MX':
        return /^\d{5}$/.test(zip)
      // Netherlands
      case '166':
      case 'NL':
        return /^\d{4}\s{0,1}[A-Za-z]{2}$/.test(zip)
      // New Zealand
      case '171':
      case 'NZ':
        return (/^\d{4}$/.test(zip))
      // Norway
      case '167':
      case 'NO':
        return (/^\d{4}$/.test(zip))
      // Poland
      case '179':
      case 'PL':
        return /^\d{2}[- ]{0,1}\d{3}$$/.test(zip)
      // Portugal
      case '184':
      case 'PT':
        return /^\d{4}$/.test(zip)
      // Romania
      case '189':
      case 'RO':
        return /^\d{6}$/.test(zip)
      // Russia
      case '190':
      case 'RU':
        return /^\d{6}$/.test(zip)
      // Slovakia
      case '201':
      case 'SK':
        return /^\d{3}\s?\d{2}$/.test(zip)
      // Slovenia
      case '199':
      case 'SI':
        return /^\d{4}$/.test(zip)
      // South Africa
      case 'ZA':
      case '244':
        return /^\d{4}$/.test(zip)
      // Spain
      case '68':
      case 'ES':
        return /^\d{5}$/.test(zip)
      // Sweden
      case '196':
      case 'SE':
        return /^\d{3}\s*\d{2}$/.test(zip)
      // Switzerland
      case '42':
      case 'CH':
        return /^\d{4}$/.test(zip)
      // Turkey
      case '222':
      case 'TR':
        return /^\d{5}$/.test(zip)
      // Ukraine
      case '227':
      case 'UA':
        return /^\d{5}$/.test(zip)
      // United Arab Emirates - no postal codes, should be empty
      case '2':
      case 'AE':
        return zip === ''
      // United Kingdom
      case '77':
      case 'GB':
      //   return /^[A-Za-z]{1,2}[\d]{1,2}([A-Za-z])?\s?[\d][A-Za-z]{2}$/.test(zip);
        return /^(\w{1,2}\d{1,2}\w?\s\d\w{1,2})$/.test(zip)
      // Vietnam
      case '238':
      case 'VN':
        return /^\d{6}$/.test(zip)
      // Invalid or not defined
      default:
        return false
    }
  },

  // format file size to B, KB, or MB (from MDN)
  formatFileSize (number) {
    if (number < 1024) {
      return number + ' bytes'
    } else if (number >= 1024 && number < 1048576) {
      return (number / 1024).toFixed(1) + ' KB'
    } else if (number >= 1048576) {
      return (number / 1048576).toFixed(1) + ' MB'
    }
  },

  getTotalFileSizes (fileElements) {
    let totalFileSize = 0

    for (const file of fileElements) {
      if (file.files.length > 0) {
        totalFileSize = totalFileSize + file.files[0].size
      }
    }

    return totalFileSize
  },

  validNetSuiteUploadSize (totalFileSize, maxFileSize = this.MAX_NETSUITE_UPLOAD_SIZE) {
    return totalFileSize < maxFileSize
  },

  updateFilesProgressBar (totalFileSize, totalTextElement, progressBarElement, percentageElement, maxFileSize = this.MAX_NETSUITE_UPLOAD_SIZE) {
    // Show files progress bar
    const filesWrapper = progressBarElement.closest('.files-wrapper')

    if (filesWrapper) {
      filesWrapper.classList.replace('hidden', 'block')
    }

    // Update bar progress + text
    const percentFileSize = Math.round((totalFileSize / maxFileSize) * 100)

    totalTextElement.innerText = this.formatFileSize(totalFileSize)
    progressBarElement.setAttribute('aria-valuenow', percentFileSize)
    progressBarElement.style.width = Math.min(Math.floor(percentFileSize), 100) + '%'
    percentageElement.innerText = percentFileSize + '%'

    // Add error if file size is too big
    if (percentFileSize >= 100) {
      progressBarElement.classList.add('progressbar-error')
    } else {
      progressBarElement.classList.remove('progressbar-error')
    }
  },

  // check that all uploaded files are proper format, takes an array of mime types like image/jpeg or application/pdf
  // the file input field should have the same mime types in its "accept" parameter
  // note that image/jpeg includes both .jpg and .jpeg file extensions
  validFileFormat (acceptedTypes, fileElements) {
    if (!acceptedTypes) {
    // no file types defined, assume all ok
      return true
    }

    let stringFileTypes = window.customerServiceErrorStrings.accepted_types
    acceptedTypes.forEach((type) => {
      stringFileTypes += '.' + type.split('/')[1] + ', '
      // for jpgs
      if (type === 'image/jpeg') {
        stringFileTypes += '.jpg, '
      }
    })
    stringFileTypes = stringFileTypes.slice(0, -2)

    for (const file of fileElements) {
      if (file.files.length > 0) {
        if (!acceptedTypes.includes(file.files[0].type)) {
          alert(window.customerServiceErrorStrings.incorrect_file_type + '. ' + stringFileTypes)
          return false
        }
      }
    }
    return true
  },

  handleCountryStateZip (countryDropdown = document.querySelector('#country-dropdown')) {
    countryDropdown.addEventListener('change', () => {
      this.updateStateField()
      this.updateZipField()
    })
  },

  updateStateField (countryField = document.querySelector('#country-dropdown'),
    stateDropdown = document.querySelector('#state-dropdown')) {
    const countryCode = countryField.options[countryField.selectedIndex].value

    switch (countryCode) {
      case '230':
      case 'US':
      // US
      // Enable state dropdown
        stateDropdown.disabled = false
        stateDropdown.closest('.a-input-select').classList.remove('hidden')
        stateDropdown.innerHTML = "<option value='' selected>Select state</option><option value='0' >Alabama</option><option value='1' >Alaska</option><option value='2' >Arizona</option><option value='3' >Arkansas</option><option value='53' >Armed Forces Americas</option><option value='52' >Armed Forces Europe</option><option value='54' >Armed Forces Pacific</option><option value='4' >California</option><option value='5' >Colorado</option><option value='6' >Connecticut</option><option value='7' >Delaware</option><option value='8' >District of Columbia</option><option value='9' >Florida</option><option value='10' >Georgia</option><option value='11' >Hawaii</option><option value='12' >Idaho</option><option value='13' >Illinois</option><option value='14' >Indiana</option><option value='15' >Iowa</option><option value='16' >Kansas</option><option value='17' >Kentucky</option><option value='18' >Louisiana</option><option value='19' >Maine</option><option value='20' >Maryland</option><option value='21' >Massachusetts</option><option value='22' >Michigan</option><option value='23' >Minnesota</option><option value='24' >Mississippi</option><option value='25' >Missouri</option><option value='26' >Montana</option><option value='27' >Nebraska</option><option value='28' >Nevada</option><option value='29' >New Hampshire</option><option value='30' >New Jersey</option><option value='31' >New Mexico</option><option value='32' >New York</option><option value='33' >North Carolina</option><option value='34' >North Dakota</option><option value='35' >Ohio</option><option value='36' >Oklahoma</option><option value='37' >Oregon</option><option value='38' >Pennsylvania</option><option value='39' >Puerto Rico</option><option value='40' >Rhode Island</option><option value='41' >South Carolina</option><option value='42' >South Dakota</option><option value='43' >Tennessee</option><option value='44' >Texas</option><option value='45' >Utah</option><option value='46' >Vermont</option><option value='47' >Virginia</option><option value='48' >Washington</option><option value='49' >West Virginia</option><option value='50' >Wisconsin</option><option value='51' >Wyoming</option>"
        break
      case '37':
      case 'CA':
      // Canada
      // Enable state dropdown
        stateDropdown.disabled = false
        stateDropdown.closest('.a-input-select').classList.remove('hidden')
        stateDropdown.innerHTML = "<option value='' selected>Select province</option><option value='101'>Alberta</option><option value='102'>British Columbia</option><option value='103'>Manitoba</option><option value='104'>New Brunswick</option><option value='105'>Newfoundland</option><option value='107'>Northwest Territories</option><option value='106'>Nova Scotia</option><option value='108'>Nunavut</option><option value='109'>Ontario</option><option value='110'>Prince Edward Island</option><option value='111'>Quebec</option><option value='112'>Saskatchewan</option><option value='113'>Yukon</option>"
        break
      case '14':
      case 'AU':
        // Australia
        // Enable state dropdown
        stateDropdown.disabled = false
        stateDropdown.closest('.a-input-select').classList.remove('hidden')
        stateDropdown.innerHTML = "<option value='' selected>Select province</option><option value='400'>Australian Capital Territory</option><option value='401'>New South Wales</option><option value='402'>Northern Territory</option><option value='403'>Queensland</option><option value='404'>South Australia/option><option value='405'>Tasmania</option><option value='406'>Victoria</option><option value='407'>Western Australia/option>"
        break
      default:
      // Others
      // Disable state dropdown
        stateDropdown.disabled = true
        stateDropdown.closest('.a-input-select').classList.add('hidden')
    }
  },

  updateZipField (countryField = document.querySelector('#country-dropdown'),
    zipField = document.querySelector('#zip-field'),
    zipLabel = document.querySelector('#zip-label')) {
    const countryCode = countryField.options[countryField.selectedIndex].value
    const requiredStar = ' *'
    const noStarZip = zipLabel.innerHTML.replace(requiredStar, '')
    const withStarZip = noStarZip + requiredStar

    switch (countryCode) {
      case '2':
      // United Arab Emirates has no postal codes
        zipField.disabled = true
        zipField.value = ''
        zipLabel.innerHTML = noStarZip
        break
      default:
        zipField.disabled = false
        zipLabel.innerHTML = withStarZip
    }
  },

  // Handle country subsidiary
  // Start change subsidiary based on country selected - CMC - 07/27/2021 */
  handleCountrySubsidiary (subsidiarySelector = '#subsidiary', countrySelector = '#country-dropdown', custLocationSelector = '.cust_location') {
    const subsidiaryElem = document.querySelector(subsidiarySelector)
    const countryDropdownElem = document.querySelector(countrySelector)
    const custLocationElem = document.querySelectorAll(custLocationSelector)

    countryDropdownElem.addEventListener('change', function () {
      switch (this.value) {
        // US/Canada/Mexico
        case 'US':
        case '230':
        case 'CA':
        case '37':
        case '157':
        case 'MX':
          if (subsidiaryElem) {
            subsidiaryElem.value = 1 // Middleby Outdoor N. America
          } else {
            console.warn('Subsidiary hidden input not found')
          }

          if (custLocationElem) {
            custLocationElem.forEach(function (item) {
              item.value = 379 // Phenix City
            })
          } else {
            console.warn('Customer Location hidden input not found')
          }
          break
        // UK/Australia/New Zealand
        case '77':
        case 'GB':
        case '14':
        case 'AU':
        case '171':
        case 'NZ':
          if (subsidiaryElem) {
            subsidiaryElem.value = 3 // KJ Uk Ltd
          } else {
            console.warn('Subsidiary hidden input not found')
          }

          if (custLocationElem) {
            custLocationElem.forEach(function (item) {
              item.value = 404 // Havant
            })
          } else {
            console.warn('Customer Location hidden input not found')
          }
          break
        default:
          if (subsidiaryElem) {
            subsidiaryElem.value = 3 // KJ UK Ltd
          } else {
            console.warn('Subsidiary hidden input not found')
          }

          if (custLocationElem) {
            custLocationElem.forEach(function (item) {
              item.value = 225 // Waddinxveen
            })
          } else {
            console.warn('Customer Location hidden input not found')
          }
          break
      }
    })
  },

  handleKJProductTypeDropdown () {
    const modelNotListedString = window.customerServiceErrorStrings.model_not_listed
    /*
    second value is for Size of Grill,
    see https://3424956.app.netsuite.com/app/common/custom/custlist.nl?id=317&e=T&ord=T to add values when a new grill or major accessory is introduced
    see https://3424956.app.netsuite.com/app/common/custom/custrecordentrylist.nl?rectype=317 and hover over edit/view to see the id
     */
    const models =
    {
      3: [
        ['BJ-ALUMN', '13', 'Aluminum Side Shelves, Big Joe', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['BJ-DJ', '17', 'DōJoe, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HCG', '13', 'Half-Moon Stainless Steel Cooking Grate, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HCGSSTONE', '13', 'Half-Moon Soapstone, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HCICG', '13', 'Half-Moon Cast Iron Cooking Grate, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HCIGRIDDLE', '13', 'Half-Moon Cast Iron Reversisble Griddle, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HDP', '13', 'Half-Moon Deflector Plates, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HDPEKIT', '13', 'HDPE Upgrade Kit, Big Joe', ['CA', 'EU', 'UK', 'US']],
        ['BJ-HSSCGFV', '13', 'Half-Moon Stainless Steel Fish & Veg Grate, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-HYPER', '13', 'SlōRoller with Rack, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-MC3', '13', 'Cart, Big Joe', ['CA', 'EU', 'UK', 'US']],
        ['BJ-MCC24', '13', 'Charcoal Basket, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-PS24', '13', 'Ceramic Pizza Stone, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-SCS', '13', 'Grill Expander, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-TISSERIEAU', '13', 'JoeTisserie, Big Joe', ['AU', 'NZ']],
        ['BJ-TISSERIEEU', '13', 'JoeTisserie, Big Joe', ['EU']],
        ['BJ-TISSERIENA', '13', 'JoeTisserie, Big Joe', ['CA', 'US']],
        ['BJ-TISSERIEUK', '13', 'JoeTisserie, Big Joe', ['UK']],
        ['KJ15090620', '13', 'Sear Plate', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15090720', '13', 'Soapstone, Joe Jr', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15091121', '13', 'Charcoal Basket, Joe Jr', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15091620', '13', 'JoeTisserie Basket Set', ['CA', 'US']],
        ['KJ15094522', '13', 'Karbon Steel Griddle, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15094622', '13', 'Karbon Steel Griddle, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15100921', '13', 'Grill Cart, Black, Classic Joe III', ['CA', 'EU', 'UK', 'US']],
        ['KJ15101021', '13', 'Grill Cart, Black, Big Joe III', ['CA', 'EU', 'UK', 'US']],
        ['KJ15112524', '13', 'Joe Jr Cart with Shelves', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15124722', '13', 'Karbon Steel Paella Pan', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15124822', '13', 'Karbon Steel Half Moon Pan Set', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15124922', '13', 'Karbon Steel Wok', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15172022', '13', 'JoeTisserie Basket Kit', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-ALUMN', '13', 'Aluminum Side Shelves, Classic Joe', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['KJ-BL', '13', 'Blow Lighter', ['CA', 'US']],
        ['KJ-CART', '13', 'Modular Cart, Classic Joe', ['CA', 'US']],
        ['KJ-CS', '13', 'Ceramic Chicken Stand', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-DDPS', '13', 'Deep Dish Pizza Stone', ['CA', 'US']],
        ['KJ-DJ', '17', 'DōJoe, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-DO', '13', 'Dutch Oven', ['CA', 'US']],
        ['KJ-ES', '13', 'Electric Starter', ['CA', 'US']],
        ['KJ-HCG', '13', 'Half-Moon Stainless Steel Cooking Grate, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-HCGSSTONE', '13', 'Half-Moon Soapstone, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-HCICG', '13', 'Half-Moon Cast Iron Cooking Grate, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-HCIGRIDDLE', '13', 'Half-Moon Cast Iron Reversisble Griddle, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-HDP', '13', 'Half-Moon Deflector Plates, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-HDPEKIT', '13', 'HDPE Upgrade Kit, Classic Joe', ['CA', 'US']],
        ['KJ-HSSCGFV', '13', 'Half-Moon Stainless Steel Fish & Veg Grate, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-HYPER', '13', 'SlōRoller with Rack, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-IHP13', '13', 'Heat Deflector, Joe Jr', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-IHPR13', '13', 'Rack Accessory, Joe Jr', ['CA', 'EU', 'UK', 'US']],
        ['KJ-MC3', '13', 'Cart, Classic Joe', ['CA', 'US']],
        ['KJ-MCC23', '13', 'Charcoal Basket, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-PC', '13', 'Pizza Cutter', ['CA', 'UA']],
        ['KJ-PP', '13', 'Pizza Peel', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-PS23', '13', 'Ceramic Pizza Stone, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-RR', '13', 'Stainless Steel Rib Rack', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-SCS', '13', 'Classic Joe Grill Expander', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-TISSERIEAU', '13', 'JoeTisserie, Classic Joe', ['AU', 'NZ']],
        ['KJ-TISSERIEEU', '13', 'JoeTisserie, Classic Joe', ['EU', 'UK']],
        ['KJ-TISSERIENA', '13', 'JoeTisserie, Classic Joe', ['CA', 'US']],
        ['KJ-TISSERIEUK', '13', 'JoeTisserie, Classic Joe', ['EU', 'UK']],
        ['KJ-WOK', '13', 'Wok', ['CA', 'UA']],
        ['PJ-STAND', '13', 'Pro Joe Stone Stand', ['CA', 'UA']],
        [modelNotListedString, '', '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      29: [
        ['BJ-GC24BWFS', '13', 'Grill Cover, Big Joe, Black', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ-GCARKANSAS', '13', 'Grill Cover, Big Joe, Arkansas', ['CA', 'US']],
        ['BJ-GCCLEMSON', '13', 'Grill Cover, Big Joe, Clemson', ['CA', 'US']],
        ['BJ-GCFLORIDA', '13', 'Grill Cover, Big Joe, Florida', ['CA', 'US']],
        ['BJ-GCMONTREAL', '13', 'Grill Cover, Big Joe, Montreal', ['CA', 'US']],
        ['BJ-GCNCAROLINA', '13', 'Grill Cover, Big Joe, North Carolina', ['CA', 'US']],
        ['BJ-GCOLEMISS', '13', 'Grill Cover, Big Joe, Ole Miss', ['CA', 'US']],
        ['BJ-GCTENNESSEE', '13', 'Grill Cover, Big Joe, Tennessee', ['CA', 'US']],
        ['KJ15080320', '13', 'Cover, Kettle Joe', ['CA', 'EU', 'UK', 'US']],
        ['KJ15080420', '13', 'Cover, Joe Jr', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15080520', '13', 'Dome Cover, Classic Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15080620', '13', 'Dome Cover, Big Joe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-GC23B.CART', '13', 'Grill Cover, Classic Joe Modular Cart', ['CA', 'US']],
        ['KJ-GC23BWFS', '13', 'Grill Cover, Classic Joe, Black', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ-GCALABAMA', '13', 'Grill Cover, Classic Joe, Alabama', ['CA', 'US']],
        ['KJ-GCAUBURN', '13', 'Grill Cover, Classic Joe, Auburn', ['CA', 'US']],
        ['KJ-GCCLEMSON', '13', 'Grill Cover, Classic Joe, Clemson', ['CA', 'US']],
        ['KJ-GCFLORIDASTATE', '13', 'Grill Cover, Classic Joe, Florida State', ['CA', 'US']],
        ['KJ-GCMONTREAL', '13', 'Grill Cover, Classic Joe, Montreal', ['CA', 'US']],
        ['KJ-GCOLEMISS', '13', 'Grill Cover, Classic Joe, Ole Miss', ['CA', 'US']],
        ['KJ-GCTENNESSEE', '13', 'Grill Cover, Classic Joe, Tennessee', ['CA', 'US']],
        [modelNotListedString, '', '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      24: [
        ['BJ24NRHC', '12', 'Big Joe II, Standalone', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ24NRHCI', '5', 'Big Joe III, Standalone', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['BJ24RH', '10', 'Big Joe I', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['BJ24RHC', '4', 'Big Joe II', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ13BH', '6', 'Joe Jr, Black', ['CA', 'US']],
        ['KJ13RH', '6', 'Joe Jr', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15040721', '19', 'Classic Joe III, Standalone', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15040821', '18', 'Big Joe III, Standalone', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15040921', '3', 'Classic Joe III', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15041021', '5', 'Big Joe III', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ15041123', '20', 'Konnected Joe', ['CA', 'US']],
        ['KJ15041523', '20', 'Konnected Joe', ['AU', 'EU', 'NZ', 'UK']],
        ['KJ15042425', '21', 'Big Joe Konnected Joe', ['CA', 'US']],
        ['KJ15042525', '21', 'Big Joe Konnected Joe,', ['AU', 'EU', 'NZ', 'UK']],
        ['KJ23B', '1', 'Classic Joe I, Black', ['CA', 'US']],
        ['KJ23BH', '1', 'Classic Joe I, Black, with tools', ['CA', 'US']],
        ['KJ23BHC', '2', 'Classic Joe II, Black', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['KJ23NRHC', '11', 'Classic Joe II, Standalone'], ['AU', 'CA', 'EU', 'NZ', 'UK', 'US'],
        ['KJ23NRHCI', '3', 'Classic Joe III, Standalone', ['CA', 'EU', 'UK', 'US']],
        ['KJ23RH', '1', 'Classic Joe I', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['KJ23RHC', '2', 'Classic Joe II', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['PJ24NRHC', '7', 'Pro Joe', ['CA', 'EU', 'UK', 'US']],
        [modelNotListedString, '', '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      21: [
        ['KJ15260020', '8', 'Pellet Joe', ['CA', 'EU', 'UK', 'US']]
      ],
      8: [
        ['KJ15040320', '9', 'Kettle Joe', ['AU', 'CA', 'EU', 'UK', 'US']]
      ]
    }

    const productTypeField = document.querySelector('#product-type-field')
    const modelSelect = document.querySelector('#model-number-select')
    const modelLabel = document.querySelector('#model-number-label')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    const requiredStar = ' *'
    const noStar = modelLabel.innerHTML.replace(requiredStar, '')
    const withStar = noStar + requiredStar

    productTypeField.addEventListener('change', () => {
      // get region every time the type changes in case they changed their country
      this.getUserRegion()
        .then((userRegion) => {
          modelSelect.length = 1
          if (models[productTypeField.value]) {
            models[productTypeField.value].forEach((element) => {
              // use this version if anything without specified regions should be included
              // if (element[3] === undefined || element[2].includes(userRegion)) {
              if (element[3] !== undefined && element[3].includes(userRegion)) {
                // element[1] is empty for Model number not listed
                if (element[2].length > 0) {
                  modelSelect.append(new Option(element[0] + ', ' + element[2], element[0] + ',' + element[1]))
                } else {
                  modelSelect.append(new Option(element[0], element[0] + ',' + element[1]))
                }
              }
            })
            /* make it required unless it is only 1 option long (that would be the Select One) */
            if (modelSelect.length > 1) {
              modelSelect.closest('.a-input-select').classList.remove('hidden')
              modelSelect.setAttribute('required', true)
              modelSelect.removeAttribute('disabled')
              modelLabel.innerHTML = withStar
            } else {
              // set the selected model number to be "Model number not listed", verbiage from Elisha
              modelNumberSubmit.value = modelNotListedString
            }
          } else if (productTypeField.value === '37') {
            /* gift card, no model number required */
            modelSelect.closest('.a-input-select').classList.add('hidden')
            modelSelect.removeAttribute('required')
            modelSelect.setAttribute('disabled', true)
            modelLabel.innerHTML = noStar
          } else {
            /* nothing to select, not required */
            modelSelect.closest('.a-input-select').classList.add('hidden')
            modelSelect.removeAttribute('required')
            modelSelect.setAttribute('disabled', true)
            modelLabel.innerHTML = noStar
          }
        })
    })
  },

  handleKJModelNumber () {
    const modelSelect = document.querySelector('#model-number-select')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    const modelNumberInput = document.querySelector('#model-number-field')
    const sizeOfGrillField = document.querySelector('#size-of-grill-field')
    modelSelect.addEventListener('change', function () {
      const values = this.value.split(',')
      modelNumberSubmit.setAttribute('value', values[0])
      sizeOfGrillField.setAttribute('value', values[1])
    })
    modelNumberInput.addEventListener('blur', function () {
      modelNumberSubmit.value = 'Other: ' + this.value
    })
  },

  handleMBProductTypeDropdown () {
    const modelNotListedString = window.customerServiceErrorStrings.model_not_listed
    const models =
    {
      3: [
        ['20091013', 'Chicken stand', ['CA', 'US']],
        ['20100115', 'Chrome wire skimmer with long handle', ['CA', 'US']],
        ['20100316', 'Cold smoker accessory kit', ['CA', 'US']],
        ['20100715', 'Grill pan and pizza stone', ['CA', 'US']],
        ['20100814', 'Universal side shelf', ['CA', 'US']],
        ['20100914', 'Smoker accessory kit', ['CA', 'US']],
        ['20101014', 'Smoker leg kit with wheels', ['CA', 'US']],
        ['MB20090719', 'Rotisserie kit', ['CA', 'US']],
        ['MB20091220', 'Gravity Series rotisserie', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20091420', 'Gravity Series 560 warming racks', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20093118', 'Smoker meat probe, 52-inch cord', ['CA', 'US']],
        ['MB20100112', 'Slow smoker', ['CA', 'US']],
        ['MB20100922', 'QuickCollapse cart', ['AU', 'CA', 'NZ', 'US']],
        ['MB20101114', 'Smoker leg extension kit', ['AU', 'CA', 'US']],
        ['MB20101719', 'Leg kit with side braces', ['CA', 'US']],
        ['MB20101819', 'Smoker side shelf', ['CA', 'US']],
        ['MB20181522', 'Gravity Series 560 front shelf', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20181622', 'Gravity Series 1050 griddle', ['CA', 'EU', 'US']],
        ['MB20181722', 'Pizza oven', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20183725', 'Flat-top Griddle Insert', ['AU', 'CA', 'NZ', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      29: [
        ['MB20080110', 'Cover, 30-inch electric smoker', ['CA', 'US']],
        ['MB20080118', 'Cover, XL propane/pellet smoker', ['CA', 'US']],
        ['MB20080119', 'Cover, 30-inch electric smoker', ['CA', 'US']],
        ['MB20080210', 'Cover, 40-inch electric smoker', ['CA', 'EU', 'UK', 'US']],
        ['MB20080220', 'Cover, Small Digital Charcoal Grill and Smoker', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20080221', 'Cover, Gravity Series 800', ['CA', 'EU', 'UK', 'US']],
        ['MB20080318', 'Cover, ThermoTemp XL and Pellet Smoker', ['CA', 'US']],
        ['MB20080319', 'Cover, 30-inch electric smoker', ['CA', 'EU', 'UK', 'US']],
        ['MB20080321', 'Cover, Digital Charcoal Smoker', ['CA', 'EU', 'UK', 'US']],
        ['MB20080418', 'Cover, Propane/Pellet smoker', ['CA', 'US']],
        ['MB20080419', 'Cover, 41-inch Propane/Pellet Smoker', ['AU', 'CA', 'NZ', 'US']],
        ['MB20080522', 'Cover, Portable Charcoal Grill', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20080924', 'Cover, 30-inch Small Smoker', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['MB20081220', 'Cover, Large Digital Charcoal Grill and Smoker', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      5: [
        ['20010610', 'Electric Fish Fryer', ['CA', 'US']],
        ['20100809', 'Oil Free', ['CA', 'US']],
        ['23010115', '8-Liter, Analog', ['CA', 'US']],
        ['23010911', 'Electric fryer', ['CA', 'US']],
        ['23011014', 'Stainless Steel, Analog', ['CA', 'US']],
        ['23011114', 'XL, Stainless Steel, Timer, Analog', ['CA', 'US']],
        ['23011514', 'No Timer', ['CA', 'US']],
        ['23013314', 'XL', ['CA', 'US']],
        ['23013414', 'XL', ['CA', 'US']],
        ['23013515', '10-Liter, Digital', ['CA', 'US']],
        ['23014314', 'XXL, Stainless Steel Lid, Digital', ['CA', 'US']],
        ['23014414', 'XXL, Stainless Steel, Digital', ['CA', 'US']],
        ['23014614', 'XXL, Black, Digital', ['CA', 'US']],
        ['MB20010118', '8-Liter Fryer/Boiler/Steamer, Analog', ['CA', 'US']],
        ['MB20012420', 'XL Fryer/Boiler/Steamer', ['CA', 'US']],
        ['MB20013020', '20-Quart Outdoor Air Fryer', ['CA', 'US']],
        ['MB23010118', '8-Liter, Stainless Steel, Analog', ['CA', 'US']],
        ['MB23010618', '10-Liter, Stainless Steel, Timer, Analog', ['CA', 'US']],
        ['MB23010718', 'Oil Free, Analog', ['CA', 'US']],
        ['MB23010809', 'Oil Free, Analog', ['CA', 'US']],
        ['MB23010818', '10-Liter, Blue, Stainless Steel Lid, Analog', ['CA', 'US']],
        ['MB23011018', '10-Liter, Onyx, Stainless Steel Lid, Analog', ['CA', 'US']],
        ['MB23011418', '10-Liter, Stainless Steel, Digital', ['CA', 'US']],
        ['MB23011518', '10-Liter, Platinum, Digital', ['CA', 'US']],
        ['MB23011618', '10-Liter, Blue, Digital', ['CA', 'US']],
        ['MB23011718', '10-Liter, Red, Digital', ['CA', 'US']],
        ['MB23011818', '10-Liter, Onyx, Digital', ['CA', 'US']],
        ['MB23011918', '10-Liter, Digital', ['CA', 'US']],
        ['MB23012418', '10-Liter, Stainless Steel Film, Analog', ['CA', 'US']],
        ['MB23012618', '10-Liter, Onyx Film, Analog', ['CA', 'US']],
        ['MB23012718', '10-Liter, Red Film, Analog', ['CA', 'US']],
        ['MB23015018', '5-Liter, Stainless Steel, Analog', ['CA', 'US']],
        ['MB23015118', '5-Liter, Stainless Steel, Thermometer, Gloves, Analog', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      6: [
        ['20020107', '30-Quart Propane', ['CA', 'US']],
        ['MB20020107', '30-Quart Propane', ['CA', 'US']],
        ['MB20020120', 'ThermoTemp Propane Fryer', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      25: [
        ['MB20040122', 'Gravity Series 800, No Griddle', ['CA', 'US']],
        ['MB20040220', 'Gravity Series 560', ['CA', 'US']],
        ['MB20041020', 'Gravity Series 560', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20040221', 'Gravity Series 800, With Griddle', ['CA', 'US']],
        ['MB20042221', 'Gravity Series 800, With Griddle', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20041023', 'Gravity Series 600', ['CA', 'US']],
        ['MB20041423', 'Gravity Series 600', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20041223', 'Gravity Series XT', ['CA', 'US']],
        ['MB20043024', 'Gravity Series XT', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20041823', 'Gravity Series 900', ['CA', 'US']],
        ['MB20041220', 'Gravity Series 1050', ['CA', 'US']],
        ['MB20041320', 'Gravity Series 1050', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20040226', 'Gravity Series 1050 with griddle', ['CA', 'US']],
        ['MB20041525', 'Gravity Series 1150', ['CA', 'US']],
        ['MB20041625', 'Gravity Series 1150', ['AU', 'EU', 'NZ', 'UK']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      16: [
        ['20060516', '30-inch, Black, 2 Doors', ['AU', 'CA', 'US']],
        ['MB20060321', '40-inch Digital Charcoal Smoker', ['CA', 'US']],
        ['MB20061321', '40-inch Digital Charcoal Smoker', ['AU', 'NZ']],
        ['MB25060616', 'Bullet Smoker, Black', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      17: [
        ['20050412', 'With Wheels and Handle', ['CA', 'US']],
        ['MB20051520', 'Dual Fuel Smoker (DE/AT)', ['EU']],
        ['MB20051620', 'Dual Fuel Smoker, No Regulator', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20054819', '2 Doors, Wheels', ['EU']],
        ['MB26050412', 'Pro Series, Black, 2 Doors', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      18: [
        ['20070111', '30-inch, Black, Analog', ['CA', 'US']],
        ['20070115', '40-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20070210', '30-inch, Black, Analog', ['CA', 'US']],
        ['20070213', '30-inch, Black, Digital', ['CA', 'US']],
        ['20070215', '40-inch, Stainless Steel Door, Window, Legs, Digital', ['CA', 'US']],
        ['20070311', '40-inch, Stainless Steel, Window, Digital', ['CA', 'US']],
        ['20070315', '40-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20070411', '30-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20070615', '40-inch, Stainless Steel Door, Window, Legs, Digital', ['CA', 'US']],
        ['20070814', '30-inch, Black, Digital, with Cover', ['CA', 'US']],
        ['20070910', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071012', '30-inch, Black, Analog', ['CA', 'US']],
        ['20071014', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071115', '40-inch, Black, Digital', ['CA', 'US']],
        ['20071117', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071217', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071218', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071317', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071517', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071612', '30-inch, Black, Digital', ['CA', 'US']],
        ['20071814', '30-inch, Black, with Meat Probes, Digital', ['CA', 'US']],
        ['20071910', '30-inch, Black, Window, Digital', ['CA', 'US']],
        ['20072215', '30-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20072315', '30-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20072415', '30-inch, Stainless Steel Door, Window, Legs, Digital', ['CA', 'US']],
        ['20072715', '30-inch, Stainless Steel Door, Window, Legs, Digital', ['CA', 'US']],
        ['20072817', 'Portable, Black, Analog', ['CA', 'US']],
        ['20072916', '40-inch, Stainless Steel, Window, Wheels, Digital', ['CA', 'US']],
        ['20073012', '40-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20073115', '30-inch, Black, Digital', ['CA', 'US']],
        ['20073315', '30-inch, Black, Digital', ['CA', 'US']],
        ['20074516', '30-inch, Red Door, Analog', ['CA', 'US']],
        ['20074517', '30-inch, Pewter Door, Analog', ['CA', 'US']],
        ['20075315', '40-inch, UBody, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20075415', '40-inch, UBody, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20075515', '40-inch, UBody, Stainless Steel Door, Window, Digital, with Cover', ['CA', 'US']],
        ['20075516', '30-inch, Black, Window, Digital, with Cover', ['CA', 'US']],
        ['20075517', '30-inch, Black, Analog', ['CA', 'US']],
        ['20075615', '40-inch, UBody, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20076716', '30-inch, Red Door, Window, Digital', ['CA', 'US']],
        ['20076816', '30-inch, Blue Door, Window, Digital', ['CA', 'US']],
        ['20076916', '30-inch, Black Door, Window, Digital', ['CA', 'US']],
        ['20077016', '30-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20077116', '30-inch, Green Door, Window, Digital', ['CA', 'US']],
        ['20077515', '30-inch, UBody, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20077615', '30-inch, UBody, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20077815', '30-inch, UBody, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['20078015', '30-inch, UBody, Stainless Steel Door, Window, Digital, with Cover', ['CA', 'US']],
        ['20078715', '30-inch, UBody, Black, Digital', ['CA', 'US']],
        ['20078815', '30-inch, UBody, Black, Digital', ['CA', 'US']],
        ['20079015', '30-inch, UBody, Black, Digital', ['CA', 'US']],
        ['MB20070115', '40-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['MB20070122', '40-inch, Legs, Digital', ['CA', 'US']],
        ['MB20070210', '30-inch, Black, 3 Racks, Analog', ['CA', 'US']],
        ['MB20070421', '30-inch, Black, Window, Legs, Digital', ['CA', 'US']],
        ['MB20070619', '30-inch, Black, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20070719', '30-inch, Black, Window, Digital', ['CA', 'US']],
        ['MB20070924', '710 Digital Electric WiFi Smoker', ['CA', 'US']],
        ['MB20071117', '30-inch, Black, Digital', ['CA', 'US']],
        ['MB20071322', '30-inch, Black, Window, Digital', ['CA', 'US']],
        ['MB20071418', '30-inch, Black, Digital', ['CA', 'US']],
        ['MB20071518', '30-inch, Stainless Steel Door, Legs, Digital', ['CA', 'US']],
        ['MB20071619', '40-inch, Black, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20071819', '40-inch, Stainless Steel Door, Window, Legs, Wheels, Digital', ['CA', 'US']],
        ['MB20072024', '710 Digital Electric WiFi Smoker', ['EU', 'UK']],
        ['MB20072124', '710 Digital Electric WiFi Smoker', ['EU', 'UK']],
        ['MB20072224', '710 Digital Electric WiFi Smoker', ['AU', 'NZ']],
        ['MB20072115', '30-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['MB20072218', '30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20072318', '30-inch, Black, Window, Digital', ['CA', 'US']],
        ['MB20072518', '30-inch, Black, Window, Digital, with Cover', ['CA', 'US']],
        ['MB20072618', '40-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20072718', '40-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20072918', '40-inch, Black, Wheels, Digital', ['CA', 'US']],
        ['MB20073018', '40-inch, Black, 2 Wheels, Legs, Digital', ['CA', 'US']],
        ['MB20073119', 'MES 130G, 30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20073220', 'MES 430G, 30-inch, Digital', ['CA', 'US']],
        ['MB20073420', 'MES 130P, 30-inch, Digital', ['EU', 'UK']],
        ['MB20073519', 'MES 130P, 30-inch, Digital', ['CA', 'US']],
        ['MB20073919', '30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20074218', '30-inch, Black, Analog', ['CA', 'US']],
        ['MB20074719', '40-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20075118', '40-inch, Stainless Steel Door, Window, Wheels, Legs, Digital'], ['CA', 'US'],
        ['MB20075519', '40-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20075617', 'MES 130B, 30-inch, Black, Digital', ['EU']],
        ['MB20075917', '40-inch, Black, Wheels, Digital', ['EU']],
        ['MB20076219', '30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20076419', '30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20076718', '40-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['MB20077018', '30-inch, Black, Digital', ['UK']],
        ['MB20077118', '40-inch, Black, Wheels, Digital', ['UK']],
        ['MB20077119', '40-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20077419', 'MES 440S, 40-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB20077618', '30-inch, 2 Racks, Legs, Analog', ['CA', 'US']],
        ['MB20078918', '30-inch, Black, Digital', ['AU', 'NZ']],
        ['MB20079218', '40-inch, Black, Wheels, Digital', ['AU', 'NZ']],
        ['MB21071012', '30-inch, Black, Analog', ['CA', 'US']],
        ['MB21071218', '30-inch, Black, Digital', ['CA', 'US']],
        ['MB21072119', '30-inch, Black, Wheels, Digital', ['CA', 'US']],
        ['MB21072218', '30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB21072319', '30-inch, Adventure Series, Window, 6 Racks, Digital', ['CA', 'US']],
        ['MB21072618', '30-inch, Adventure Series, Window, 6 Racks, Digital', ['CA', 'US']],
        ['MB21072719', '40-inch, Adventure Series, Window, 6 Racks, Digital', ['CA', 'US']],
        ['MB21072918', '40-inch, Black, Wheels, Digital', ['CA', 'US']],
        ['MB21076819', '30-inch, Black, Window, Legs, 2 Wheels, Digital', ['CA', 'US']],
        ['MB21077819', '40-inch, Black, Window, Legs, 2 wheels, 2 Casters, Digital', ['CA', 'US']],
        ['MB25071217', '30-inch, JMSS, Black, Digital', ['CA', 'US']],
        ['MB25072215', '30-inch, Stainless Steel Door, Window, Digital', ['CA', 'US']],
        ['MB25073519', '30-inch, Stainless Steel Door, Window, Wheels, Digital', ['CA', 'US']],
        ['MB25075517', '30-inch, Black, Legs, Analog', ['CA', 'US']],
        ['MB26071317', '30-inch, Black, Digital', ['CA', 'US']],
        ['MB26072415', '30-inch, Stainless Steel Door, Window, Wheels, Legs, Digital', ['CA', 'US']],
        ['MB26073519', '30-inch, Black, Window, Wheels, Legs, Digital', ['CA', 'US']],
        ['MB28071517', '30-inch, Black, Digital', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      19: [
        ['20050211', '40-inch, Black', ['CA', 'US']],
        ['20051314', '44-inch, Black, 2-doors, window', ['CA', 'US']],
        ['20051316', '40-inch, Black, 2-doors, window', ['CA', 'US']],
        ['20051416', '40-inch, Black, 2-doors, window', ['CA', 'US']],
        ['20051713', '30-inch, 2 racks', ['CA', 'US']],
        ['MB20050118', '30-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB20050211', '40-inch, Black', ['CA', 'US']],
        ['MB20050418', '40-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB20050511', '30-inch, 2 racks', ['CA', 'US']],
        ['MB20050614', '44-inch, Black, 2-doors, window'], ['CA', 'US'],
        ['MB20050716', '30-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB20051311', '30-inch, Black, 2-doors', ['CA', 'US']],
        ['MB20051316', '40-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB20052318', '30-inch, Black, 2-doors', ['CA', 'US']],
        ['MB21050813', '30-inch, Black, 2-doors', ['CA', 'US']],
        ['MB21050814', '40-inch, Black, 2-doors, 6 racks', ['CA', 'US']],
        ['MB21050916', '30-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB21051213', '40-inch, Black', ['CA', 'US']],
        ['MB21051313', '40-inch, Black', ['CA', 'US']],
        ['MB21051314', '44-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB21051416', '40-inch, Black, 2-doors, window', ['CA', 'US']],
        ['MB25050217', '30-inch, Black, 2-doors', ['CA', 'US']],
        ['MB25050816', '30-inch, Black, 2-doors, window', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      28: [
        ['MB20041124', 'AutoIgnite Series 545', ['CA', 'US']],
        ['MB20040522', 'Portable Charcoal Grill', ['CA', 'US']],
        ['MB20040622', 'Portable Charcoal Grill', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20040722', 'Portable Charcoal Grill, with cart', ['CA', 'US']],
        ['MB20040819', 'Charcoal Wagon, 30-inch (76 cm)', ['CA', 'US']],
        ['MB20040822', 'Portable Charcoal Grill, with cart', ['AU', 'EU', 'NZ', 'UK']],
        ['MB20040919', 'Charcoal Wagon, 36-inch (91 cm)', ['CA', 'US']],
        ['MB20041819', 'Kamado Grill', ['CA', 'EU', 'UK', 'US']],
        ['MB20042724', 'AutoIgnite Series 545', ['AU', 'EU', 'NZ', 'UK']],
        ['SH19041319', 'Smoke Hollow Charcoal Wagon, 30-inch (76 cm)', ['CA', 'US']],
        ['SH19041519', 'Smoke Hollow Charcoal Wagon,  36-inch (91 cm)', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ]
    }

    const productTypeField = document.querySelector('#product-type-field')
    const modelSelect = document.querySelector('#model-number-select')
    // const modelText = document.querySelector('#model-number-text')
    const modelLabel = document.querySelector('#model-number-label')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    // const modelLabel2 = document.querySelector('#model-number-label2')
    const requiredStar = ' *'
    const noStar = modelLabel.innerHTML.replace(requiredStar, '')
    const withStar = noStar + requiredStar
    // leave star on both - doesn't matter because hidden when not required
    modelLabel.innerHTML = withStar
    // modelLabel2.innerHTML = withStar

    productTypeField.addEventListener('change', () => {
      // get region every time the type changes in case they changed their country
      this.getUserRegion()
        .then((userRegion) => {
          modelSelect.length = 1
          if (models[productTypeField.value]) {
            models[productTypeField.value].forEach((element) => {
              // use this version if anything without specified regions should be included
              // if (element[2] === undefined || element[2].includes(userRegion)) {
              if (element[2] !== undefined && element[2].includes(userRegion)) {
                // element[1] is empty for Model number not listed
                if (element[1].length > 0) {
                  modelSelect.append(new Option(element[0] + ', ' + element[1], element[0]))
                } else {
                  modelSelect.append(new Option(element[0], element[0]))
                }
              }
            })
            /* make it required unless it is only 1 option long (that would be the Select One) */
            if (modelSelect.length > 1) {
              modelSelect.closest('.a-input-select').classList.remove('hidden')
              modelSelect.setAttribute('required', true)
              modelSelect.removeAttribute('disabled')
              modelLabel.innerHTML = withStar
            } else {
              // set the selected model number to be "Model number not listed", verbiage from Elisha
              modelNumberSubmit.value = modelNotListedString
            }
          } else if (productTypeField.value === '37') {
            /* gift card, no model number required */
            modelSelect.closest('.a-input-select').classList.add('hidden')
            modelSelect.removeAttribute('required')
            modelSelect.setAttribute('disabled', true)
            modelLabel.innerHTML = noStar
          } else {
            /* nothing to select, not required */
            modelSelect.closest('.a-input-select').classList.add('hidden')
            modelSelect.removeAttribute('required')
            modelSelect.setAttribute('disabled', true)
            modelLabel.innerHTML = noStar
          }
        })
    })
  },

  handleMBModelNumber () {
    const modelSelect = document.querySelector('#model-number-select')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    const modelText = document.querySelector('#model-number-text')
    modelSelect.addEventListener('change', function () {
      const values = this.value.split(',')
      modelNumberSubmit.setAttribute('value', values[0])
    })
    modelText.addEventListener('blur', function () {
      modelNumberSubmit.value = 'Other: ' + this.value
    })
  },
  handleCGProductTypeDropdown () {
    const modelNotListedString = window.customerServiceErrorStrings.model_not_listed
    const models =
    {
      29: [
        ['CG30083425', 'Cover, Universal Barrel Grill', ['CA', 'EU', 'UK', 'US']],
        ['1055', 'Cover, Gambler and Maverick', ['AU', 'CA', 'NZ', 'US']],
        ['13737', 'Cover, Outlaw / Smokin\' Outlaw', ['CA', 'US']],
        ['15555', 'Cover, Super Pro / Pro Deluxe / Deluxe Griller', ['CA', 'US']],
        ['1655', 'Cover, Smokin\' Champ', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['16755', 'Cover, AKORN', ['AU', 'CA', 'US']],
        ['18080', 'Cover, Double Play DFGC Grill (Home Depot)', ['CA', 'US']],
        ['2187', 'Cover, Traditional', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['2323', 'Cover, Wrangler', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['2455', 'Cover, Table Top', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['2955', 'Cover, Legacy Grill Cover', ['CA', 'US']],
        ['3055', 'Cover, Grillin Pro3', ['CA', 'US']],
        ['3087', 'Cover, 3 Burner Gas Grill', ['CA', 'US']],
        ['3737', 'Cover, Outlaw', ['CA', 'US']],
        ['5055', 'Cover, Dual Function 2 Burner Grill Cover', ['CA', 'US']],
        ['5533', 'Cover, Universal', ['AU', 'CA', 'NZ', 'US']],
        ['5555', 'Cover, Super Pro / Pro Deluxe / Deluxe Griller', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['6060', 'Cover, Patio Pro', ['CA', 'US']],
        ['6455', 'E6480 Grill Cover', ['CA', 'US']],
        ['6555', 'Cover, AKORN w/ Cart', ['CA', 'US']],
        ['6659', 'Cover, AKORN Jr.', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['6755', 'Cover, AKORN', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['8055', 'Cover, Texas Trio (Home Depot)', ['CA', 'US']],
        ['8075', 'Cover, Griddle, 4 Burner', ['CA', 'US']],
        ['8080', 'Cover, Duo', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['8087', 'Cover, Dual Function Grill', ['CA', 'US']],
        ['8175', '2 Burner Griddle Cover', ['CA', 'US']],
        ['8195', 'Cover, Grand Champ, 8100', ['CA', 'US']],
        ['8265', 'Grand Champ Grill Cover', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['8275', 'Cover, Griddle, Portable', ['CA', 'US']],
        ['8295', 'Dakota 8235 Grill Cover', ['CA', 'US']],
        ['8355', '3 Burner Griddle Cover', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['8575', 'Cover, Premium Griddle', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['8787', 'Cover, Hybrid Gas & Charcoal', ['CA', 'US']],
        ['8955', 'Cover, Competition Pro', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['9155', 'Cover, Pellet Grill', ['CA', 'US']],
        ['9875', 'Gravity Fed Cover', ['CA', 'US']],
        ['9955', 'Tank Cover', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      30: [
        ['102535', 'Grate Lifter', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['1135', 'Grate Hook', ['CA', 'US']],
        ['19586', 'Charcoal Chimney', ['AU', 'CA', 'US']],
        ['4040', 'Charcoal Basket', ['AU', 'CA', 'US']],
        ['5022', 'Rotisserie Kit', ['CA', 'US']],
        ['6201', 'Smokin\' Stone', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['6202', 'Pizza Stone 15"', ['CA', 'US']],
        ['6204', 'U-Rack Rib Rack', ['CA', 'US']],
        ['6205', 'Drip Pan', ['CA', 'US']],
        ['6206', 'Wireless Remote Thermometer', ['CA', 'US']],
        ['6211', 'Smokin\' Stone Jr.', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['6214', 'AKORN Adjustable Fire Grate', ['AU', 'CA', 'US']],
        ['6304', 'Pocket (Folding Probe) Thermometer', ['CA', 'US']],
        ['6315', 'Remote Thermometer', ['CA', 'US']],
        ['8603', '3n1 Brush (scour pad + nylon bristles)', ['CA', 'US']],
        ['8605', 'Basting Brush', ['CA', 'EU', 'UK', 'US']],
        ['8607', 'Tongs', ['CA', 'EU', 'UK', 'US']],
        ['8609', 'Spray Bottle', ['CA', 'EU', 'UK', 'US']],
        ['8611', 'Scrub Brush', ['AU', 'CA', 'US']],
        ['8621', 'Bristle Free Brush - 3 Head', ['CA', 'EU', 'UK', 'US']],
        ['8651', 'Tool Kit (Spat/Tong/Fork)', ['AU', 'EU', 'UK']],
        ['8805', 'Apron', ['CA', 'US']],
        ['8813', 'Burger Press', ['AU', 'CA', 'US']],
        ['8814', 'Bacon Press', ['CA', 'US']],
        ['8842', 'Magnetic Tool Hooks 3pk', ['CA', 'US']],
        ['8860', 'Grill Glove', ['CA', 'EU', 'UK', 'US']],
        ['9305', 'Grate Scraper', ['CA', 'US']],
        ['9580', 'Charcoal Chimney', ['CA', 'US']],
        ['9586', 'Charcoal Chimney', ['CA', 'US']],
        ['CG30183225', 'Charcoal Chimney', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      31: [
        ['8760', 'Universal Griddle Stand', ['CA', 'US']],
        ['8879', 'Heavy Duty Griddle Spatula', ['CA', 'US']],
        ['8903', 'Grease Cup Liners 10pk', ['CA', 'US']],
        ['8905', 'Griddle Starter Kit (2 Spatulas + 2 Liquid Dispensers + Chopper)', ['CA', 'EU', 'UK', 'US']],
        ['8922', 'Griddle Cleaning Kit (Brush + Scour pads', ['CA', 'US']],
        ['8933', 'Breakfast Kit', ['CA', 'US']],
        ['8966', 'Flat Iron 12" Melting Dome', ['CA', 'EU', 'UK', 'US']],
        ['8977', 'Griddle Scraper', ['CA', 'US']],
        ['E8940', 'Flat Iron Portable LP Tank Adapter Kit', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      32: [
        ['6203', 'Wok', ['CA', 'US']],
        ['6207', 'Turkey Roaster', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      33: [
        ['9800', 'Gravity Fed Charcoal - Blue', ['AU', 'CA', 'US']],
        ['9804', 'Gravity Fed Charcoal - Red', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      7: [
        ['1016', 'Maverick', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['1224', 'Smokin\' Pro', ['CA', 'US']],
        ['1329', 'Smokin\' Pro', ['CA', 'US']],
        ['1416', 'Gambler', ['CA', 'US']],
        ['1515', 'Patio Pro', ['AU', 'CA', 'US']],
        ['1616', 'Patio Pro, steel shelf', ['AU', 'CA', 'NZ', 'US']],
        ['1624', 'Smokin\' Champ', ['CA', 'US']],
        ['1733', 'Smokin\' Champ', ['CA', 'EU', 'US']],
        ['1816', 'Portable Gambler', ['CA', 'US']],
        ['2121', 'Super Pro', ['CA', 'US']],
        ['2123', 'Wrangler', ['CA', 'US']],
        ['2130', 'Blazer', ['CA', 'US']],
        ['2137', 'Outlaw', ['CA', 'US']],
        ['2175', 'Classic', ['CA', 'US']],
        ['2197', '30" Traditional Charcoal Grill', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['2223', 'Wrangler, steel shelf', ['CA', 'US']],
        ['2525', 'Super Pro 2.0', ['CA', 'US']],
        ['2623', 'Wrangler', ['CA', 'US']],
        ['2727', 'Deluxe Barrel Charcoal Grill', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['2735', 'Pro Deluxe XL', ['CA', 'US']],
        ['2799', 'Raider', ['CA', 'US']],
        ['2823', 'Wrangler, metal shelves', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['2828', 'Pro Deluxe', ['CA', 'US']],
        ['2929', 'Pro Deluxe, steel shelf', ['AU', 'CA', 'US']],
        ['3018', 'Smokin\' Ace', ['CA', 'US']],
        ['3724', 'Smokin\' Outlaw', ['CA', 'US']],
        ['8100', 'Grand Champ HD Barrel', ['CA', 'US']],
        ['8125', 'Competition Pro', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['8235', 'Dakota Offset Smoker', ['CA', 'US']],
        ['8250', 'Grand Champ', ['AU', 'CA', 'NZ', 'US']],
        ['A8125', 'Competition Pro', ['AU', 'NZ']],
        ['CG30040825', 'Barrel Pro', ['CA', 'US']],
        ['CG30043324', 'Wrangler', ['AU', 'NZ', 'EU']],
        ['CG30043424', 'Pro Deluxe', ['AU', 'NZ', 'EU']],
        ['CG30043524', 'Smokin\' Pro', ['AU', 'NZ']],
        ['CG30044223', 'Smokin\' Pro', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['E1016', 'Maverick', ['CA', 'US']],
        ['E1224', 'Smokin\' Pro', ['CA', 'US']],
        ['E1416', 'Gambler', ['CA', 'US']],
        ['E1515', 'Patio Pro', ['CA', 'US']],
        ['E1733', 'Smokin\' Champ 2.0', ['CA', 'US']],
        ['E1816', 'Portable Gambler', ['CA', 'US']],
        ['E2123', 'Wrangler', ['CA', 'US']],
        ['E2130', 'Blazer', ['CA', 'US']],
        ['E2175', 'Classic', ['CA', 'US']],
        ['E2197', '30-inch Traditional Charcoal Grill', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['E2727', 'Pro Deluxe', ['CA', 'US']],
        ['E2735', 'Pro Deluxe XL', ['CA', 'US']],
        ['E2827', 'Pro Deluxe', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['E2828', 'Deluxe Griller', ['AU', 'CA', 'US']],
        ['E3018', 'Smokin\' Ace', ['CA', 'US']],
        ['E3724', 'Smokin\' Outlaw', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      21: [
        ['9020', 'Pellet Grill Char-Griller', ['AU', 'CA', 'US']],
        ['9040', 'Pellet Grill Char-Griller', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      34: [
        ['2903', 'Stealth 3 Burner Gas Grill with Side Burner', ['CA', 'US']],
        ['3001', 'Grillin\' Pro, Gas', ['CA', 'US']],
        ['3072', '3 Burner Gas Grill', ['CA', 'US']],
        ['3138', '3 Burner Camp Stove', ['CA', 'US']],
        ['3338', '3 Burner Camp Stove', ['CA', 'US']],
        ['E3001', 'Grillin\' Pro, Gas', ['CA', 'US']],
        ['E3072', '3 Burner Gas Grill', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      35: [
        ['3070', 'Texas Trio Gas/Charcoal/SFB', ['AU', 'CA', 'NZ', 'US']],
        ['5030', 'Dual 2 Burner Gas & Charcoal Grill', ['AU', 'CA', 'US']],
        ['5037', 'Dual Threat', ['CA', 'US']],
        ['5050', 'Duo, Gas & Charcoal Grill', ['AU', 'CA', 'US']],
        ['5072', 'Dual 3 Burner Gas & Charcoal Grill', ['AU', 'CA', 'US']],
        ['5650', 'Double Play - Dual Function Gas & Charcoal Grill', ['AU', 'CA', 'NZ', 'US']],
        ['5750', 'Hybrid Gas & Charcoal Grill', ['CA', 'US']],
        ['CG30281224', 'FlexFuel Plus', ['CA', 'US']],
        ['CG30282925', 'FlexFuel', ['CA', 'US']],
        ['CG30283925', 'Double Play Gas & Charcoal Grill (EU/UK)', ['EU', 'UK']],
        ['CG30284025', 'Double Play Gas & Charcoal Grill (DE/AT)', ['EU', 'UK']], // no regions in NetSuite, going off name and Anne's list
        ['E5030', 'Dual 2 Burner Gas & Charcoal Grill', ['CA', 'US']],
        ['E5037', 'Dual Threat', ['CA', 'US']],
        ['E5072', 'Dual 3 Burner Gas & Charcoal Grill', ['CA', 'US']],
        ['E5750', 'Hybrid Gas & Charcoal Grill', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      36: [
        ['8036', 'Flat Iron Gas Griddle', ['AU', 'CA', 'NZ', 'US']],
        ['8128', 'Flat Iron 2 Burner Griddle', ['AU', 'CA', 'NZ', 'US']],
        ['8136', 'Flat Iron Gas Griddle with Hinged Lid (36-inch)', ['AU', 'CA', 'NZ', 'US']],
        ['8217', 'Flat Iron Portable Griddle'], ['AU', 'CA', 'NZ', 'US'],
        ['8328', 'Flat Iron 3 Burner Griddle, Gray, Lid and Control', ['CA', 'US']],
        ['8428', 'Flat Iron 3 Burner Griddle', ['AU', 'CA', 'NZ', 'US']],
        ['8536', 'Flat Iron Premium Griddle', ['AU', 'CA', 'NZ', 'US']],
        ['8728', 'Flat Iron 2 Burner Griddle with Lid, 28-inch', ['CA', 'US']],
        ['8730', 'Flat Iron 3 Burner Griddle with Lid, 30-inch', ['AU', 'CA', 'US']],
        ['8736', 'Flat Iron 4 Burner Griddle With Removable Lid, 36-inch', ['CA', 'US']],
        ['8936', 'Flat Iron 3 Burner Griddle', ['CA', 'US']],
        ['8928', 'Flat Iron 2 Burner Griddle No Lid', ['CA', 'US']],
        ['CG30285325', 'Double Play Gas & Charcoal Grill', ['UK']],
        ['CG30354225', 'Flat Iron 3 Burner Gas Griddle (no regulator)', ['EU', 'UK']],
        ['CG30354325', 'Flat Iron 3 Burner Gas Griddle (DE/AT)', ['EU']],
        ['CG30354525', 'Flat Iron Premium Gas Griddle (no regulator)', ['AU', 'EU', 'NZ', 'UK']],
        ['CG30354625', 'Flat Iron Premium Gas Griddle (DE/AT)', ['EU']],
        ['CG30354826', 'Flat Iron 4 Burner Gas Griddle', ['AU', 'NZ']],
        ['CG30354926', 'Flat Iron 3 Burner Griddle', ['AU', 'NZ']],
        ['CG30355125', 'Flat Iron Premium Gas Griddle', ['UK']],
        ['CG30355225', 'Flat Iron 3 Burner Gas Griddle', ['UK']],
        ['E8428', 'Flat Iron 3 Burner Griddle', ['CA', 'US']],
        ['E8936', 'Flat Iron 4 Burner Gas Griddle', ['AU', 'CA', 'US', 'NZ']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ],
      27: [
        ['12197', 'Traditional Charcoal Grill', ['CA', 'US']],
        ['16820', 'AKORN Kamado, Graphite', ['AU', 'CA', 'US']],
        ['16620', 'AKORN, Graphite,  Metal Side Shelves', ['CA', 'US']],
        ['2190', 'Legacy Charcoal Grill', ['AU', 'CA', 'US']],
        ['22424', 'Tabletop Grill + SFB', ['AU', 'CA', 'US']],
        ['32424', 'Tabletop Grill + SFB, black wooden handle', ['CA', 'US']],
        ['52424', 'Tabletop Grill + SFB, 25mm handle', ['CA', 'US']],
        ['6520', 'AKORN Kamado with Cart, Gray', ['CA', 'US']],
        ['6614', 'AKORN Jr. Kamado', ['AU', 'CA', 'US']],
        ['6620', 'AKORN, Red', ['AU', 'CA', 'US']],
        ['6714', 'AKORN Jr., Black', ['AU', 'CA', 'EU', 'UK', 'US']],
        ['6719', 'AKORN, Black', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['7400', 'Flavor Pro Multi-Fuel Grill', ['CA', 'US']],
        ['92424', 'Tabletop Grill + SFB', ['CA', 'US']],
        ['96619', 'AKORN Kamado Multi-pak, Graphite', ['CA', 'US']],
        ['96719', 'AKORN Kamado Combo Pk, Black', ['AU', 'NZ']],
        ['CG30040725', '22-inch (57 cm) Kettle Grill', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['CG30042824', 'AKORN Gray', ['AU', 'NZ']],
        ['CG30043224', 'Side Fire Box', ['AU', 'EU', 'NZ', 'UK']],
        ['CG30043726', 'AKORN Jr., Black', ['AU', 'NZ']],
        ['E06614', 'AKORN, Red', ['AU', 'NZ']],
        ['E06620', 'AKORN, Red', ['CA', 'US']],
        ['E16820', 'AKORN, Graphite', ['CA', 'US']],
        ['E22424', 'Side Fire Box', ['AU', 'CA', 'US']],
        ['E36714', 'AKORN Jr. Kamado, Orange', ['CA', 'US']],
        ['E4822', 'Premium Kettle Grill, Black', ['CA', 'US']],
        ['E56714', 'AKORN Jr. Kamado, Blue', ['CA', 'US']],
        ['E6480', 'AKORN Auto-Kamado', ['AU', 'CA', 'NZ', 'US']],
        ['E6714', 'AKORN Jr. Kamado, Black', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']],
        ['E82424', 'Tabletop Grill + SFB', ['AU', 'CA', 'NZ', 'US']],
        ['E86714', 'AKORN Jr. Kamado, Gray', ['CA', 'US']],
        ['E92424', 'Tabletop Grill + SFB, sheet metal legs', ['CA', 'US']],
        [modelNotListedString, '', ['AU', 'CA', 'EU', 'NZ', 'UK', 'US']]
      ]
    }

    const productTypeField = document.querySelector('#product-type-field')
    const modelSelect = document.querySelector('#model-number-select')
    const modelLabel = document.querySelector('#model-number-label')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    const requiredStar = ' *'
    const noStar = modelLabel.innerHTML.replace(requiredStar, '')
    const withStar = noStar + requiredStar
    // leave star on both - doesn't matter because hidden when not required
    modelLabel.innerHTML = withStar

    productTypeField.addEventListener('change', () => {
      // get region every time the type changes in case they changed their country
      this.getUserRegion()
        .then((userRegion) => {
          modelSelect.length = 1
          if (models[productTypeField.value]) {
            models[productTypeField.value].forEach((element) => {
              // use this version if anything without specified regions should be included
              // if (element[2] === undefined || element[2].includes(userRegion)) {
              if (element[2] !== undefined && element[2].includes(userRegion)) {
                // element[1] is empty for Model number not listed
                if (element[1].length > 0) {
                  modelSelect.append(new Option(element[0] + ', ' + element[1], element[0]))
                } else {
                  modelSelect.append(new Option(element[0], element[0]))
                }
              }
            })
            /* make it required unless it is only 1 option long (that would be the Select One) */
            if (modelSelect.length > 1) {
              modelSelect.setAttribute('required', true)
              modelSelect.removeAttribute('disabled')
              modelSelect.closest('.a-input-select').classList.remove('hidden')
            } else {
              // set the selected model number to be "Model number not listed", verbiage from Elisha
              modelNumberSubmit.value = modelNotListedString
            }
          } else {
            /* nothing to select, not required */
            modelSelect.removeAttribute('required')
            modelSelect.setAttribute('disabled', true)
            modelSelect.closest('.a-input-select').classList.add('hidden')
          }
        })
    })
  },

  handleCGModelNumber () {
    const modelSelect = document.querySelector('#model-number-select')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    modelSelect.addEventListener('change', function () {
      const values = this.value.split(',')
      modelNumberSubmit.setAttribute('value', values[0])
    })
  },

  handleNewsletterOptIn (optIn = document.querySelector('#opt-in'),
    optInValue = document.querySelector('#opt-in-value')) {
    optIn.addEventListener('click', function () {
      if (this.checked) {
        optInValue.value = 'T'
      } else {
        optInValue.value = 'F'
      }
    })
  },

  handleEmailFieldMatching (emailField = document.querySelector('#email-field'),
    confirmEmailField = document.querySelector('#confirm-email-field')) {
    // Check 2 email fields match
    confirmEmailField.addEventListener('blur', () => {
      if (emailField.value !== '' &&
        confirmEmailField.value !== '') {
        this.validateEmail(emailField, confirmEmailField)
      }
    })
    emailField.addEventListener('blur', () => {
      if ((emailField.value !== '' &&
        confirmEmailField.value !== '') &&
        confirmEmailField.value) {
        this.validateEmail(emailField, confirmEmailField)
      }
    })
  },

  // Format date input field
  formatDate (purchaseDateField = document.getElementById('purchase-date-field'),
    newDate = document.getElementById('new-date')) {
    let newFormat = ''
    let oldFormat = purchaseDateField.value
    const regEx = /^\d{4}-\d{2}-\d{2}$/

    if (!oldFormat.match(regEx)) {
      alert(window.customerServiceErrorStrings.date_format)
      return false
    }

    const year = oldFormat.substring(0, oldFormat.indexOf('-'))
    oldFormat = oldFormat.substring(oldFormat.indexOf('-') + 1)
    let month = oldFormat.substring(0, oldFormat.indexOf('-'))

    if (month.charAt(0) === '0') {
      month = month.substring(1)
    }

    oldFormat = oldFormat.substring(oldFormat.indexOf('-') + 1)
    let day = oldFormat

    if (day.charAt(0) === '0') {
      day = day.substring(1)
    }

    newFormat = month + '/' + day + '/' + year
    newDate.value = newFormat
  },

  // Get user region based on current country
  getUserRegion () {
    // Including all current countries even if we don't sell there yet
    // Including ISO codes and NetSuite internal IDs that we have. Countries should come in as NetSuite IDs but this may change in the future. (10/29/2025)
    // Do not have regions for Argentina (11), Israel (103), South Africa (244), United Arab Emirates (2), Vietnam (238)
    const regions = {
      EU: ['AT', '13', 'BE', '20', 'BG', '22', 'HR', '97', 'CY', '55', 'CZ', '56', 'DK', '59', 'EE', '64', 'FI', '70', 'FR', '75', 'DE', '57', 'GR', '89', 'HU', '100', 'IE', '102', 'IT', '110', 'LV', '135', 'LT', '133', 'LU', '134', 'MT', '153', 'NL', '166', 'PL', '179', 'PT', '184', 'RO', '189', 'RU', '190', 'SK', '201', 'SL', '199', 'ES', '68', 'SE', '196', 'AL', 'AD', 'AM', 'BY', 'BA', 'FO', 'GE', 'IS', '109', 'XK', 'LI', 'MK', 'MD', 'MC', 'ME', 'NO', '167', 'SM', 'RS', 'CH', '42', 'TR', '222', 'UA', '227', 'VA'],
      UK: ['UK', '77', 'GI', 'IM'],
      US: ['US', '230'],
      CA: ['CA', '37'],
      AU: ['AU', '14'],
      NZ: ['NZ', '171'],
      MX: ['MX', '157']
    }
    // figure out the region code for the user
    // use US for default country and region
    const userCountry = document.getElementById('country-dropdown').value || 'US default'
    let userRegion = 'US' // default to US, because we need something

    for (const region in regions) {
      if (regions[region].includes(userCountry)) {
        userRegion = region
      }
    }
    return Promise.resolve(userRegion)
  },

  showError (fieldElement, message) {
    // Show error message UI
    fieldElement.classList.add('error')

    // Attept to add aria-invalid to field
    if (fieldElement.querySelector('input')) {
      fieldElement.querySelector('input').setAttribute('aria-invalid', 'true')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'true')
    } else if (fieldElement.querySelector('select')) {
      fieldElement.querySelector('select').setAttribute('aria-invalid', 'true')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'true')
    }

    // Show error message
    if (message) {
      const errorElem = fieldElement.querySelector('.error-message p')

      if (errorElem) {
        errorElem.innerHTML = message
      } else {
        console.error('Unable to show error on fieldElement:', fieldElement, 'with message:', message)
      }
    } else {
      console.error('Unable to show error on fieldElement:', fieldElement, '. Has no message:', message)
    }
  },

  hideError (fieldElement) {
    // Hide error message UI
    fieldElement.classList.remove('error')

    // Disable aria-invalid if used
    if (fieldElement.querySelector('input')) {
      fieldElement.querySelector('input').setAttribute('aria-invalid', 'false')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'false')
    } else if (fieldElement.querySelector('select')) {
      fieldElement.querySelector('select').setAttribute('aria-invalid', 'false')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'false')
    }
  },

  hideAllErrors () {
    // text errors
    document.querySelectorAll('.a-input-text.error').forEach((field) => {
      this.hideError(field)
    })

    // select errors
    document.querySelectorAll('.a-input-select.error').forEach((field) => {
      this.hideError(field)
    })

    // date errors
    document.querySelectorAll('.a-input-date.error').forEach((field) => {
      this.hideError(field)
    })

    // file errors
    document.querySelectorAll('.a-input-file.error').forEach((field) => {
      this.hideError(field)
    })
  },

  // Focus on first error in the form
  focusFirstError (container = document.querySelector('#support-form')) {
    let firstError = container.querySelector('.a-input-text.error input, .a-input-text.error textarea, .a-input-select.error select, .a-input-date.error input, .a-input-file.error input')

    // focus on first name field if no visible errors
    if (!firstError) {
      firstError = container.querySelector('#first-name-field')
    }
    firstError.focus()
  },

  // Look for required input fields and if empty, show error message
  validateRequiredFields (container) {
    let formIsValid = true

    const requiredFields = [
      {
        container: '.a-input-text',
        input: 'input[required]'
      },
      {
        container: '.a-input-text',
        input: 'textarea[required]'
      },
      {
        container: '.a-input-select',
        input: 'select[required]'
      },
      {
        container: '.a-input-date',
        input: 'input[required]'
      },
      {
        container: '.a-input-file',
        input: 'input[required]'
      }
    ]

    for (const fieldType of requiredFields) {
      const fields = container.querySelectorAll(`${fieldType.container}:not(.hidden) ${fieldType.input}`)

      for (const field of fields) {
        if ((fieldType.container !== '.a-input-file' && field.value === '') || (fieldType.container === '.a-input-file' && field.files.length === 0)) {
          const fieldContainer = field.closest(fieldType.container)

          // Show error message
          if (fieldContainer) {
            this.showError(fieldContainer, window.customerServiceErrorStrings.required_error)
          } else {
            console.error('Could not find container for field: ', field)
          }

          formIsValid = false
        }
      }
    }

    return formIsValid
  },

  validateEmail (email = document.querySelector('#email-field'),
    confirmEmail = document.querySelector('#confirm-email-field')) {
    const emailValue = email.value
    const confirmEmailValue = confirmEmail.value
    const emailContainer = email.closest('.a-input-text')
    const confirmEmailContainer = confirmEmail.closest('.a-input-text')

    if (emailValue === confirmEmailValue && this.validEmail(emailValue)) {
      this.hideError(emailContainer)
      this.hideError(confirmEmailContainer)

      return true
    } else if (emailValue !== confirmEmailValue) {
      this.showError(emailContainer, window.customerServiceErrorStrings.emails_dont_match)
      this.showError(confirmEmailContainer, window.customerServiceErrorStrings.emails_dont_match)

      return false
    } else {
      this.showError(emailContainer, window.customerServiceErrorStrings.email_not_valid)
      this.showError(confirmEmailContainer, window.customerServiceErrorStrings.email_not_valid)

      return false
    }
  },

  // Handle file validation
  handleFileValidation (fileSections = ['receipt', 'model', 'additional'],
    fileSelector = 'input[type=file]',
    warningIconSelector = '.files-warning',
    progressTextSelector = '#files-progress-text',
    percentageSelector = '#percent-file-size') {
    for (const file of document.querySelectorAll(fileSelector)) {
      file.addEventListener('change', () => {
      // Run validation
        const okFileSize = this.validateFileSizes(fileSections)
        const okFileFormat = this.validateFileFormat()

        if (okFileSize && okFileFormat) {
          const warningIcons = document.querySelectorAll(warningIconSelector)
          const progressTextElement = document.querySelector(progressTextSelector)
          const percentageElement = document.querySelector(percentageSelector)

          // Remove any error messages from previous uploads
          progressTextElement.classList.remove('progressbar-error-text')
          percentageElement.classList.add('progressbar-error-text')
          warningIcons.forEach(icon => icon.classList.add('hidden'))
        }
      })
    }
  },

  // Make sure all files attached to a form are under 10MB (NetSuite limit). See contact and registration forms.
  validateFileSizes (fileSections = ['receipt', 'model', 'additional'],
    fileElements = document.querySelectorAll('input[type=file]'),
    warningIcons = document.querySelectorAll('.files-warning'),
    totalTextElement = document.querySelector('#totalFileSize'),
    progressTextElement = document.querySelector('#files-progress-text'),
    percentageElement = document.querySelector('#percent-file-size'),
    progressBarElement = document.querySelector('#files-progress-bar')) {
    // Validate total files size
    const total = this.getTotalFileSizes(fileElements)
    const ok = this.validNetSuiteUploadSize(total)

    // Update progress bar
    this.updateFilesProgressBar(total, totalTextElement, progressBarElement, percentageElement)

    // Other UI updates
    if (ok) {
      // Update file/image preview
      for (const section of fileSections) {
        this.updatePreview(section)
      }
    } else {
      alert(window.customerServiceErrorStrings.files_too_large)

      progressTextElement.classList.add('progressbar-error-text')
      percentageElement.classList.add('progressbar-error-text')
      warningIcons.forEach(icon => icon.classList.remove('hidden'))
    }

    return ok
  },

  validateFileFormat (fileElements = document.querySelectorAll('input[type=file]'),
    warningIcons = document.querySelectorAll('.files-warning'),
    progressTextElement = document.querySelector('#files-progress-text'),
    percentageElement = document.querySelector('#percent-file-size')) {
    const ok = this.validFileFormat(['image/jpeg', 'image/png', 'image/gif', 'application/pdf'], fileElements)

    if (!ok) {
      alert(window.customerServiceErrorStrings.accepted_formats)

      progressTextElement.classList.add('progressbar-error-text')
      percentageElement.classList.add('progressbar-error-text')
      warningIcons.forEach(icon => icon.classList.remove('hidden'))
    }

    return ok
  },

  validateBannedName (firstName, lastName) {
    const badValues = ['duesediefe', 'dymnminam', 'rorequip']
    if (badValues.includes(firstName.toLowerCase()) || badValues.includes(lastName.toLowerCase()) || firstName.toLowerCase() === lastName.toLowerCase()) {
      return false
    }
    return true
  },

  updatePreview (sectionType) {
    const previewContainer = document.querySelector(`#${sectionType}-image-preview`)
    previewContainer.classList.replace('hidden', 'flex')
    previewContainer.innerHTML = ''

    for (const file of document.querySelector(`.${sectionType}-files input[type=file]`).files) {
      if (file.type.includes('image')) {
        previewContainer.innerHTML += `
                <div class="flex flex-row gap-x-4 mb-4">
                    <div class="w-1/2">
                        <img id="${sectionType}-image-preview-image" src="${URL.createObjectURL(file)}" alt="${file.name}" width="400" height="auto">
                    </div>
                    <div class="w-1/2">
                        <div class="flex flex-col gap-y-4 justify-between p-2">
                            <p id="${sectionType}-image-preview-name" class="text-label-1 font-bold">${file.name}</p>
                            <p id="${sectionType}-image-preview-size" class="text-label-2">${this.formatFileSize(file.size)}</p>
                        </div>
                    </div>
                </div>
            `
      } else {
        previewContainer.innerHTML += `
                <div class="flex flex-col gap-y-4 mb-4">
                    <p class="text-h4"><i class="fa fa-file" area-hidden="true"></i></p>
                    <p id="${sectionType}-image-preview-name" class="text-label-1 font-bold">${file.name}</p>
                    <p id="${sectionType}-image-preview-size" class="text-label-2">${this.formatFileSize(file.size)}</p>
                </div>
            `
      }
    }
  }
}
